/*
 * @Description: 实现一个拖拽指令，可在页面可视区域任意拖拽元素。
<template>
<div class="el-dialog" v-drag></div>
</template>
*/
const drag = {
  inserted(el) {
    el.style.cursor = 'move'
    console.log(el)
    console.dir(el)
    el.onmousedown = function(e) {
      //获取鼠标点击处分别与div左边和div上边的距离：鼠标位置-div位置
      let startX = e.clientX - el.offsetLeft,
        startY = e.clientY - el.offsetTop
      document.onmousemove = function(ev) {
        let event = ev || window.event
        let moveX = event.clientX - startX
        let moveY = event.clientY - startY
        el.style.left = moveX + 'px'
        el.style.top = moveY + 'px'
      }
      // 鼠标弹起时不再移动
      document.onmouseup = function() {
        document.onmousemove = document.onmouseup = null
      }
    }
  },
}
export default drag
